/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import {detectIE} from "../../../utils";
import React from "react";

const isIE = detectIE();

export const Picture = ({ children }) => isIE ? <React.Fragment>{children}</React.Fragment> : <picture>{children}</picture>;
